import { call } from "redux-saga/effects";
import { apiRequest } from "../../../Utils/axiosApi";

export function* fetchOrgById(orgId) {
  try {
    const result = yield call(apiRequest, {
      url: "/organizations/" + orgId,
      method: "GET",
    });

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiBuildSite(action) {
  try {
    const result = yield call(apiRequest, {
      method: "POST",
      url: "/jenkins/job/build",
      data: action.data,
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* createStagingDomain(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/siteDetails/create/stagingDomain`,
      method: "POST",
      data: action.data,
    });
    if (result.isApiSuccessful) {
      action.meta.onSuccess(result.data);
      return result;
    } else {
      action.meta.onError(result.data);
      return { isApiSuccessful: false, data: null };
    }
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
